/* @flow */

import React from 'react';

import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import IntlMessageComponent from 'components/formatters/intlMessage';

type UnknownCompanyOfferSuccessViewComponentProps = {
};

export default function UnknownCompanyOfferSuccessViewComponent(props: UnknownCompanyOfferSuccessViewComponentProps) {
  return (
    <React.Fragment>
      <Paper elevation={0}>
        <Box mt={3} p={3}>
            <IntlMessageComponent id="offeruc.success.message" />
        </Box>
      </Paper>

      
    </React.Fragment>
  );
}
